function Hx50(props) {
  return (
    <svg
      width={250}
      height={44}
      viewBox="0 0 250 44"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon_hsx50</title>
      <path
        d="M63.484.108l-7.61 43.218h-8.643l2.778-15.787H11.422L8.644 43.326H0L7.622.108h8.643l-3.3 18.788h38.588L54.84.108h8.643zm122.767 8.536L187.776 0H135.88c-.6 0-1.112.431-1.216 1.022l-4.275 24.245h43.551a.617.617 0 01.617.726l-1.102 6.248a3.087 3.087 0 01-3.037 2.553h-32.33a.617.617 0 01-.618-.726l.559-3.161h-8.644l-1.562 8.915a3.087 3.087 0 003.041 3.624h38.896c5.993 0 11.12-4.303 12.16-10.205l2.287-12.984a3.087 3.087 0 00-3.037-3.624h-40.613l1.315-7.47a.617.617 0 01.618-.51l43.761-.01zm8.792 0h44.644a.617.617 0 01.617.725l-3.979 22.563a3.087 3.087 0 01-3.04 2.553h-33.417a.617.617 0 01-.618-.726l3.396-19.343h-8.644l-4.46 25.406a3.087 3.087 0 003.04 3.624h39.986a12.348 12.348 0 0012.163-10.205l5.22-29.608A3.087 3.087 0 00246.911 0h-41.567c-5.076 0-9.419 3.645-10.301 8.644zM127.323 0H114.22L96.997 15.074 84.028 0H71.535l18.334 21.316-25.255 22.121h13.422L95.59 27.965l13.274 15.417h12.496l-18.66-21.68L127.322 0z"
        fill={props.color || "#000"}
        fillRule="nonzero"
      />
    </svg>
  );
}

export default Hx50;
